import React, { useContext } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
// material
import { styled } from '@mui/material/styles';
import { Card, Typography, Alert, List, ListItem, ListItemText, Divider, Box } from '@mui/material';
// context
import { ReportContext } from '../../../contexts/Report';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(5, 5)
  }
}));

const IconWrapperStyle = styled('div')(() => ({
  margin: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

// ----------------------------------------------------------------------

export default function AppBuyers() {
  const { sales, isLoading, hasError } = useContext(ReportContext);

  if (hasError) {
    return (
      <Alert severity="error">
        An error occurred while trying to load the buyers — Please, try to refresh the page!
      </Alert>
    );
  }

  return (
    <RootStyle>
      <Box pl={2} pr={{ xs: 2, md: 5 }} textAlign="center">
        {isLoading ? (
          <Typography align="center" variant="h3">
            <CircularProgress size={30} color="inherit" />
          </Typography>
        ) : (
          <IconWrapperStyle>
            <Typography variant="h2">{sales.paid.buyers.quantity}</Typography>
          </IconWrapperStyle>
        )}
        <Typography variant="subtitle2" sx={{ opacity: 1 }}>
          Buyers
        </Typography>
      </Box>
      <Divider orientation="vertical" flexItem sx={{ mr: { sm: 0, md: 2 } }} />
      {isLoading ? (
        <Typography sx={{ width: '100%' }} align="center" variant="h3">
          <CircularProgress size={30} color="inherit" />
        </Typography>
      ) : (
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
          <ListItem>
            <ListItemText primary="Order Average" />
            <ListItemText sx={{ textAlign: 'right' }} primary={sales.paid.buyers.average.order} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Ticket Average" />
            <ListItemText sx={{ textAlign: 'right' }} primary={sales.paid.buyers.average.ticket} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Amount Average" />
            <ListItemText
              sx={{ textAlign: 'right' }}
              primary={`${sales.paid.buyers.average.amount} €`}
            />
          </ListItem>
        </List>
      )}
    </RootStyle>
  );
}
